import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { Link } from 'react-router-dom'
import { Avatar, HorizontalStack, IconValueBlock, ShowIf, Status } from '@ztechapps/webui.util'
import type { Company, UserProfile, UserStatusEnum } from '@ztechapps/common.contract'
import { PhoneNumberDisplay } from '../PhoneNumber/PhoneNumberDisplay'

export type CollaboratorsWidgetProps = {
  profile?: UserProfile
  status?: UserStatusEnum
  linkTo?: string
  company?: Company
  phone?: string
  showAvatar?: boolean
}
export const CollaboratorsWidget = ({ profile, status, linkTo, company, phone, showAvatar = true }: CollaboratorsWidgetProps) => {
  const name = isEmpty(company?.name) ? profile?.name : company?.name
  return (
    <HorizontalStack gap={2} className="align-items-start">
      <ShowIf condition={showAvatar}>
        <div>
          <Avatar name={name} />
        </div>
      </ShowIf>
      <div>
        <div className="fw-bold">
          {status && <Status value={status} />}
          {isEmpty(linkTo) ? `${name}` : <Link to={linkTo}>{name}</Link>}
        </div>

        <ShowIf condition={!isEmpty(profile?.name)}>
          <div className="small">
            <IconValueBlock icon="address-card" value={profile?.name} />
          </div>
        </ShowIf>
        <ShowIf condition={!!profile?.email}>
          <div className="small">
            <IconValueBlock icon="envelope">
              <a href={`mailto:${profile?.email}`}>{profile?.email}</a>
            </IconValueBlock>
          </div>
        </ShowIf>
        <ShowIf condition={!!phone}>
          <div className="small">
            <IconValueBlock icon="phone">
              <a href={`tel:${phone}`}>
                <PhoneNumberDisplay value={phone} />
              </a>
            </IconValueBlock>
          </div>
        </ShowIf>
      </div>
    </HorizontalStack>
  )
}
